export interface Group<TKey, TElement> extends Iterable<TElement> {
  key: TKey;
}
